import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

// Standardized checkbox wrapper with label for consistent usage across the app
export interface StandardCheckboxProps {
  id: string;
  label: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
  labelClassName?: string;
  disabled?: boolean;
}

export const StandardCheckbox = React.forwardRef<
  React.ElementRef<typeof Checkbox>,
  StandardCheckboxProps
>(({ id, label, checked, onCheckedChange, className, labelClassName, disabled, ...props }, ref) => {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <Checkbox
        ref={ref}
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className="rounded-full"
        {...props}
      />
      <label 
        htmlFor={id} 
        className={cn(
          "cursor-pointer text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
          labelClassName
        )}
      >
        {label}
      </label>
    </div>
  );
});

StandardCheckbox.displayName = "StandardCheckbox";

// Export the base Checkbox component for direct usage
export { Checkbox as BaseCheckbox } from "@/components/ui/checkbox";

// Default export for convenience
export default StandardCheckbox;